import React, { useEffect, useState } from 'react';
import { LockIcon, MenuIcon, XIcon } from 'lucide-react';
const NAV_LINKS = [{
  label: 'Qué incluye',
  href: '#incluye'
}, {
  label: 'Los Bonos',
  href: '#bonos'
}, {
  label: 'Oferta',
  href: '#oferta'
}, {
  label: 'Garantía',
  href: '#garantia'
}, {
  label: 'Preguntas',
  href: '#preguntas'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-[60px] z-50 w-full border-b transition-colors duration-300 sm:top-[64px] ${scrolled ? 'bg-[#111111]/95 backdrop-blur-md border-[#D89A3D]/20' : 'bg-[#111111] border-transparent'}`} data-id="element-137" data-mp="36bbifkhcqwny">
      

      {open && <nav className="border-t border-[#EFEDE8]/10 bg-[#111111] px-4 pb-4 pt-2 lg:hidden" aria-label="Navegación móvil" data-id="element-138" data-mp="3fbzvabv0eqz9">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="block border-b border-[#EFEDE8]/5 py-3 text-sm font-medium text-[#EFEDE8]/80" data-id="element-139" data-mp="2rl8bir6ksf0n">
              {link.label}
            </a>)}
          <a href="#oferta" onClick={() => setOpen(false)} className="mt-3 block rounded-md bg-[#FF7A00] px-4 py-3 text-center font-display text-sm font-extrabold uppercase tracking-wider text-[#111111]" data-id="element-140" data-mp="2hodfcexryqpj">
            Ver oferta
          </a>
        </nav>}
    </header>;
}